import CardBody from "components/common/CardBody";
import CardHeader from "components/common/CardHeader";
import CustomCard from "components/common/CustomCard";
import React from "react";
import MissionActorsRenderRow from "../MissionActorsRenderRow";

const MissionActorsComponent = ({ tableData, correspondenceLoading, canChangeMissionActors, handleAddClick, handleUpdate, handleDeleteClick }) => {
    return (
        <React.Fragment>
            <CustomCard>
                <CardHeader className='border border-bottom'>
                    <h2>Mission Actors</h2>
                </CardHeader>
                <CardBody>
                    <table className="table table-bordered">
                        <thead className="bg-primary text-white">
                            <tr>
                                <th width="50" className="text-center">
                                    #
                                </th>
                                <th>Mission Actors</th>
                                <th>Users</th>
                                {
                                    canChangeMissionActors() && (
                                        <th>Action</th>
                                    )
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                tableData?.map((actor, index) => (
                                    <MissionActorsRenderRow
                                        config={{
                                            isActors: true
                                        }}
                                        actor={actor}
                                        index={index}
                                        correspondenceLoading={correspondenceLoading}
                                        handleAddClick={handleAddClick}
                                        handleUpdate={handleUpdate}
                                        handleDeleteClick={handleDeleteClick}
                                        canChangeMissionActors={canChangeMissionActors}
                                    />
                                ))
                            }
                        </tbody>
                    </table>
                </CardBody>
            </CustomCard>
        </React.Fragment>
    );
}

MissionActorsComponent.defaultProps = {
    tableData: [],
    correspondenceLoading: false,
    canChangeMissionActors: () => false,
    handleAddClick: () => { },
    handleUpdate: () => { },
    handleDeleteClick: () => { },
};

export default MissionActorsComponent;